export const ERROR_ACCOUNT_PASSWORD_RESUSE = 'errors.com.epicgames.account.old_password_reuse';
export const ERROR_ACCOUNT_VALIDATION_FAILURE = 'errors.com.epicgames.validation.validation_failed';

export const ERROR_META_DATA_BAD_DEFINITION = 'errors.com.epicgames.account.auth_app.bad_definition_format';
